import React from 'react';
import { useIntl } from 'react-intl';
import VolumetricModularImg from '../images/fusion-log.png';
import Icons from '../../../components/Icons/Icons';
import css from './Sections.module.css';

function SectionsFusionLog() {
  const intl = useIntl();

  return (
    <div className={css.fusionLogSections}>
      <div className={css.fixedWidthContainer}>
        <h2>{intl.formatMessage({ id: 'SectionsFusionLog.title' })}</h2>
        <div className={css.volumetricModularContent}>
          <div className={css.volumetricModularImg}>
            <img src={VolumetricModularImg} alt="" />
          </div>
          <div className={css.volumetricModularInfo}>
            <p>{intl.formatMessage({ id: 'SectionsFusionLog.description1' })}</p>
            <p>{intl.formatMessage({ id: 'SectionsFusionLog.description2' })}</p>
          </div>
        </div>
        <div className={css.logPoints}>
          <ul>
            {['list1', 'list2', 'list3'].map((key, i) => (
              <li key={i}>
                <Icons name="checkListIcon" />
                {intl.formatMessage({ id: `SectionsFusionLog.${key}` })}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SectionsFusionLog;
